import { LayerProps } from 'shared/map-exports';

const ICONS_MIN_ZOOM = 8; // ~state level

export const getIconStyle = (selectedGeoEventId: number): LayerProps => ({
  type: 'symbol',
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-allow-overlap': true,
    'icon-anchor': 'center',
    'icon-ignore-placement': false,
    // Match location icon sizing
    'icon-size': [
      'interpolate',
      ['linear'],
      ['zoom'],
      ICONS_MIN_ZOOM,
      0.85,
      10,
      1,
      13,
      1.25,
    ],
    'icon-offset': [
      ['get', 'offsetX'],
      ['get', 'offsetY'],
    ],
    'symbol-sort-key': ['get', 'index'],
    'symbol-z-order': 'source',
  },
  paint: {
    'icon-opacity': [
      'step',
      ['zoom'],
      ['case', ['==', ['get', 'id'], selectedGeoEventId], 1, 0],
      ICONS_MIN_ZOOM,
      ['get', 'opacity'],
    ],
  },
});
